import React, { useState } from 'react';
import { Box, Heading, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import ConsultantForm from './ConsultantForm';
import { createAdminConsultant } from './adminConsultantsApi';

const normalizeApiErrors = (error) => {
  const rawErrors = error?.response?.data?.errors;
  if (!rawErrors) return { base: 'Could not save consultant. Please try again.' };

  if (Array.isArray(rawErrors)) {
    return { base: rawErrors.join(', ') };
  }

  if (typeof rawErrors === 'object') {
    return Object.entries(rawErrors).reduce((acc, [key, value]) => {
      acc[key] = Array.isArray(value) ? value.join(', ') : String(value);
      return acc;
    }, {});
  }

  return { base: 'Could not save consultant. Please try again.' };
};

const ConsultantCreatePage = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiErrors, setApiErrors] = useState({});

  const handleCreate = async (payload) => {
    setIsSubmitting(true);
    setApiErrors({});
    try {
      await createAdminConsultant({ consultant: payload });
      toast({
        title: 'Consultant created',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      navigate('/app/admin/consultants');
    } catch (error) {
      console.error('Error creating consultant:', error);
      setApiErrors(normalizeApiErrors(error));
      toast({
        title: 'Could not create consultant',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box p={6}>
      <Heading as="h2" size="lg" mb={6}>
        Create Consultant
      </Heading>
      <ConsultantForm
        title="Create Consultant"
        onSubmit={handleCreate}
        onCancel={() => navigate('/app/admin/consultants')}
        isSubmitting={isSubmitting}
        submitLabel="Create Consultant"
        apiErrors={apiErrors}
      />
    </Box>
  );
};

export default ConsultantCreatePage;
